export default __webpack_public_path__ + "static/media/GreenThik.2f083634.svg";